<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <div class="row">
          <div class="col-md-8">
            <h3 class="mt-1">{{ catalogueItem.name }}</h3>

            <h5>
              <span
                v-if="catalogueItem.on_promotion == 1"
                class="badge badge-primary mr-2"
                >On Promotion</span
              >

              <span
                v-if="catalogueItem.is_active == 1"
                class="badge badge-success"
                >Active</span
              >
              <span
                v-if="catalogueItem.is_active == 0"
                class="badge badge-danger"
                >InActive</span
              >
            </h5>

            <div class="my-3" v-if="userHasPerms(['Manage catalogue'])">
              <router-link
                v-b-tooltip.hover
                title="Edit"
                :to="{
                  name: 'catalogue-item-edit',
                  params: { id: catalogueItem.id },
                }"
                class="text-primary table-action-icon ml-0"
              >
                <i class="lni lni-pencil"></i>
              </router-link>

              <span
                v-b-tooltip.hover
                style="cursor: pointer"
                title="Delete"
                @click="confirmDelete(catalogueItem.id)"
                class="text-danger table-action-icon"
              >
                <i class="lni lni-trash"></i>
              </span>
            </div>
          </div>
          <div class="col-md-4 text-center text-md-right">
            <v-lazy-image
              v-if="catalogueItem.default_image"
              :src="catalogueItem.default_image.medium"
              class="img-fluid maxHeight200 mb-2"
            />
          </div>
        </div>

        <b-tabs class="mt-3">
          <b-tab title="Details">
            <table class="table table-sm mt-2">
              <table-row
                label="Description"
                :noBorder="true"
                v-if="catalogueItem.description"
                >{{ catalogueItem.description }}</table-row
              >

              <table-row label="Group"
                >{{ catalogueItem.product_group.name }}
              </table-row>

              <table-row label="Supplier"
                >{{ catalogueItem.supplier.name }}
              </table-row>

              <table-row label="Brand"
                >{{ catalogueItem.brand.name }}
              </table-row>

              <table-row
                label="Cooking Instructions"
                v-if="catalogueItem.cooking_instructions"
                >{{ catalogueItem.cooking_instructions }}</table-row
              >

              <table-row label="Flavours"
                >{{ catalogueItem.flavours }}
              </table-row>

              <table-row label="Portion Size"
                >{{ catalogueItem.portion_size }}
              </table-row>

              <table-row label="Portions Per Pack"
                >{{ catalogueItem.portions_per_pack }}
              </table-row>

              <table-row label="Case Size"
                >{{ catalogueItem.case_size }}
              </table-row>

              <table-row label="Promote">
                <b-form-checkbox
                  style="margin-top: -7px"
                  :disabled="true"
                  v-model="catalogueItem.on_promotion"
                  value="1"
                  unchecked-value="0"
                  switch
                />
              </table-row>

              <table-row
                label="Promote Description"
                v-if="catalogueItem.promotion_description"
                >{{ catalogueItem.promotion_description }}</table-row
              >

              <table-row label="Pre Cooked">
                <b-form-checkbox
                  style="margin-top: -7px"
                  :disabled="true"
                  v-model="catalogueItem.is_precooked"
                  value="1"
                  unchecked-value="0"
                  switch
                />
              </table-row>

              <table-row label="Deep Fry">
                <b-form-checkbox
                  style="margin-top: -7px"
                  :disabled="true"
                  v-model="catalogueItem.can_deep_fry"
                  value="1"
                  unchecked-value="0"
                  switch
                />
              </table-row>

              <table-row label="Bake">
                <b-form-checkbox
                  style="margin-top: -7px"
                  :disabled="true"
                  v-model="catalogueItem.can_bake"
                  value="1"
                  unchecked-value="0"
                  switch
                />
              </table-row>

              <table-row label="No Hormones">
                <b-form-checkbox
                  style="margin-top: -7px"
                  :disabled="true"
                  v-model="catalogueItem.no_hormones"
                  value="1"
                  unchecked-value="0"
                  switch
                />
              </table-row>

              <table-row label="No Antibiotics">
                <b-form-checkbox
                  style="margin-top: -7px"
                  :disabled="true"
                  v-model="catalogueItem.no_antibiotics"
                  value="1"
                  unchecked-value="0"
                  switch
                />
              </table-row>

              <table-row label="No Animal By-Products">
                <b-form-checkbox
                  style="margin-top: -7px"
                  :disabled="true"
                  v-model="catalogueItem.no_animal_by_products"
                  value="1"
                  unchecked-value="0"
                  switch
                />
              </table-row>

              <table-row icon="lni-database" :noBorder="true" />

              <table-row label="Id">{{ catalogueItem.id }} </table-row>

              <table-row label="Created"
                >{{
                  moment(new Date(catalogueItem.created_at)).format(
                    "DD MMM YYYY, HH:mm:ss"
                  )
                }}
              </table-row>
              <table-row label="Updated"
                >{{
                  moment(new Date(catalogueItem.updated_at)).format(
                    "DD MMM YYYY, HH:mm:ss"
                  )
                }}
              </table-row>
            </table>
          </b-tab>

          <b-tab title="Images" :active="imagesTabActive">
            <div class="row my-5">
              <div class="col-12">
                <div class="border">
                  <div v-if="loading">
                    <b-spinner
                      variant="primary"
                      style="width: 3rem; height: 3rem"
                      label="Large Spinner"
                    ></b-spinner>
                  </div>

                  <div
                    v-for="catalogueImage in catalogueItem.catalogue_item_images"
                    :key="catalogueImage.id"
                    class="card border-bottom p-2 mb-1"
                  >
                    <img
                      v-if="catalogueImage.medium"
                      :src="catalogueImage.medium"
                      class="img-fluid maxWidth300 my-2"
                    />
                    <p class="nl2br font-weight-bold bg-light p-1">
                      <span
                        class="text-primary"
                        v-if="catalogueImage.is_default == 1"
                        >Default Image -
                      </span>
                      {{ catalogueImage.caption }}
                    </p>

                    <div class="my-1" v-if="userHasPerms(['Manage catalogue'])">
                      <span
                        v-b-tooltip.hover
                        style="cursor: pointer"
                        title="Edit"
                        @click="imageToEdit = catalogueImage"
                        class="text-primary table-action-icon ml-0"
                      >
                        <i class="lni lni-pencil"></i>
                      </span>

                      <span
                        v-b-tooltip.hover
                        style="cursor: pointer"
                        title="Delete"
                        @click="deleteImage(catalogueImage)"
                        class="text-danger table-action-icon"
                      >
                        <i class="lni lni-trash"></i>
                      </span>

                      <form-base
                        v-if="imageToEdit.id == catalogueImage.id"
                        :submit-status="submitStatus"
                        action="Update"
                        :errors="errors"
                        :loading="loading"
                        v-on:handleSubmit="updateImage"
                      >
                        <template v-slot:fields>
                          <form-group label="Caption" :required="true">
                            <input
                              type="text"
                              class="form-control"
                              v-model="imageToEdit.caption"
                            />
                          </form-group>

                          <form-group label="Is Default">
                            <b-form-checkbox
                              v-model="imageToEdit.is_default"
                              value="1"
                              unchecked-value="0"
                              switch
                              size="lg"
                            >
                            </b-form-checkbox>
                          </form-group>
                        </template>
                      </form-base>
                    </div>
                  </div>

                  <form-base
                    v-if="userHasPerms(['Manage catalogue'])"
                    :submit-status="submitStatus"
                    action="Upload"
                    :errors="errors"
                    :loading="loading"
                    v-on:handleSubmit="createImage"
                  >
                    <template v-slot:fields>
                      <form-group label="Caption" :required="true">
                        <input
                          type="text"
                          class="form-control"
                          v-model="newImage.caption"
                        />
                      </form-group>

                      <form-group label="Is Default">
                        <b-form-checkbox
                          v-model="newImage.is_default"
                          value="1"
                          unchecked-value="0"
                          switch
                          size="lg"
                        >
                        </b-form-checkbox>
                      </form-group>

                      <form-group label="Image">
                        <image-upload
                          :key="imageKey"
                          @files-uploaded="
                            newImage.image_id = $event;
                            imageUploading = false;
                          "
                          @files-uploaded-started="imageUploading = true"
                          :multiple="false"
                          :imageCrop="false"
                          :validationState="imageVstate"
                          acceptedTypes="image/*"
                        ></image-upload>
                      </form-group>
                    </template>
                  </form-base>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import catalogueRepo from "@/api/repos/catalogueRepo";
import tableRow from "@/components/common/TableRow";
import imageUpload from "@/components/common/ImageUpload";
import formGroup from "@/components/common/FormGroup";
import formBase from "@/components/common/FormBase";

export default {
  props: ["id"],

  components: {
    tableRow,
    formBase,
    formGroup,
    imageUpload,
  },

  mounted() {
    this.getCatalogueItem();
  },

  data() {
    return {
      loading: false,
      catalogueItem: {
        product_group: {},
        supplier: {},
        brand: {},
      },
      newImage: { image_id: null, caption: null, is_default: 0 },
      submitStatus: null,
      errors: null,
      imageUploading: false,
      imageKey: 1,
      fileUploading: false,
      imagesTabActive: false,
      imageToEdit: {},
    };
  },

  methods: {
    async getCatalogueItem() {
      try {
        this.loading = true;
        let { data } = await catalogueRepo.get(this.id);
        this.catalogueItem = data.catalogueItem;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async deleteCatalogueItem(id) {
      this.isBusy = true;
      try {
        await catalogueRepo.delete(id);
        this.$emit("catalogueItemUpdated");
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
    confirmDelete(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete the item.", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((confirm) => (confirm ? this.deleteCatalogueItem(id) : false))
        .catch((error) => console.log(error));
    },
    async createImage() {
      this.loading = true;
      this.submitStatus = "PENDING";

      if (this.newImage.image_id == null) {
        this.$root.$bvToast.toast("Upload image", {
          title: "Errors on form data",
          autoHideDelay: 3000,
          variant: "danger",
        });
        this.submitStatus = "ERROR";
        this.loading = false;
      } else if (this.imageUploading == true) {
        this.$root.$bvToast.toast("Wait for Image Upload", {
          title: "Errors on form",
          autoHideDelay: 3000,
          variant: "danger",
        });
        this.submitStatus = "ERROR";
        this.loading = false;
      } else {
        try {
          let { data } = await catalogueRepo.image(
            this.catalogueItem,
            this.newImage
          );
          this.catalogueItem = data.catalogueItem;
          this.newImage = {
            image_id: null,
            caption: null,
            is_default: 0,
          };
          this.imageKey++;
          this.imagesTabActive = true;
          this.$emit("catalogueItemImageUpdated");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          } else {
            this.$root.$bvToast.toast("Something Went Wrong", {
              title: error.response.data.message,
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
    async deleteImage(image) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete the image.", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (confirm) => {
          if (confirm) {
            this.loading = true;
            this.submitStatus = "PENDING";

            try {
              let { data } = await catalogueRepo.imageDelete(
                this.catalogueItem,
                image
              );
              this.catalogueItem = data.catalogueItem;
              this.$emit("catalogueItemImageUpdated");
              this.imagesTabActive = true;
            } catch (error) {
              console.log(error);
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.$root.$bvToast.toast("Form Errors", {
                  title: "Errors on form data",
                  autoHideDelay: 3000,
                  variant: "danger",
                });
              } else {
                this.$root.$bvToast.toast("Something Went Wrong", {
                  title: error.response.data.message,
                  autoHideDelay: 3000,
                  variant: "danger",
                });
              }
            } finally {
              this.loading = false;
              this.submitStatus = null;
            }
          }
        })
        .catch((error) => console.log(error));
    },
    async updateImage() {
      this.loading = true;
      this.submitStatus = "PENDING";

      try {
        let { data } = await catalogueRepo.imageUpdate(
          this.catalogueItem,
          this.imageToEdit
        );
        this.catalogueItem = data.catalogueItem;
        this.imageToEdit = {};
        this.imagesTabActive = true;
        this.$emit("catalogueItemImageUpdated");
      } catch (error) {
        console.log(error);
        if (error.response.status === 422) {
          this.errors = error.response.data.errors;
          this.$root.$bvToast.toast("Form Errors", {
            title: "Errors on form data",
            autoHideDelay: 3000,
            variant: "danger",
          });
        } else {
          this.$root.$bvToast.toast("Something Went Wrong", {
            title: error.response.data.message,
            autoHideDelay: 3000,
            variant: "danger",
          });
        }
      } finally {
        this.loading = false;
        this.submitStatus = null;
      }
    },
  },

  computed: {
    imageVstate() {
      return null;
    },
  },
};
</script>
